// client/src/modules/huddle/index.ts
import { COLLECTIONS } from '../../config/collections';
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Huddle Hub module manifest (P16)
 *
 * OfficeHub-native operating rhythm — recurring meetings with AI Briefings,
 * action items with branch-scoped carry-forward, decisions, announcements
 * (email + Google Chat), Vision/Traction Organizer, and a read-only
 * accountability chart summary. Replaces Moose.
 *
 * Status remains 'in_development' until v1 ships (target: ~5 weeks per
 * PRD §12 phasing). Sub-plan 2 (Meetings) is the next sub-plan to build.
 */
export const huddleModule: ModuleManifest = {
  id: 'P16',
  name: 'Huddle Hub',
  shortName: 'Huddle',
  description:
    'Operating rhythm — recurring meetings, action items, decisions, announcements, vision/strategy, accountability chart. Replaces Moose.',
  icon: '🤝',
  status: 'live',
  urlPrefix: '/huddle',
  routes,
  navItems,
  collections: {
    HUDDLE_MEETING_TEMPLATES: COLLECTIONS.HUDDLE_MEETING_TEMPLATES,
    HUDDLE_MEETING_INSTANCES: COLLECTIONS.HUDDLE_MEETING_INSTANCES,
    HUDDLE_ACTION_ITEMS: COLLECTIONS.HUDDLE_ACTION_ITEMS,
    HUDDLE_ROCKS: COLLECTIONS.HUDDLE_ROCKS,
    HUDDLE_DECISIONS: COLLECTIONS.HUDDLE_DECISIONS,
    HUDDLE_ANNOUNCEMENTS: COLLECTIONS.HUDDLE_ANNOUNCEMENTS,
    HUDDLE_ANNOUNCEMENT_DELIVERIES: COLLECTIONS.HUDDLE_ANNOUNCEMENT_DELIVERIES,
    HUDDLE_VTO: COLLECTIONS.HUDDLE_VTO,
    HUDDLE_ACTIVITY_FEED: COLLECTIONS.HUDDLE_ACTIVITY_FEED,
  },
};

export default huddleModule;
